import { ERentalType } from '../types';

export enum EMapEventName {
  MAP_VIEW_TOGGLED = 'Map View Toggled',
  LISTING_MARKER_PREVIEWED = 'Listing Marker Previewed',
  SEARCH_AS_MAP_MOVE_TOGGLED = 'Search As Map Move Toggled',
  SEARCH_MAP_EXPANDED = 'Search Map Expanded',
}

export interface IMapEventInfo {
  isEnabled: boolean;
}

export enum EMapStatus {
  EXPANDED = 'expanded',
  COLLAPSED = 'collapsed',
}

export interface IListingMarkerPreviewedEvent {
  rentalID: number;
  rentalType: ERentalType;
  isCampground: boolean;
  markersOnMap: number;
  isInstabook: boolean;
  pricePerNight: number;
  basePricePerNight: number;
  discountPercentOff: number;
  currentPageViewed: number;
  mapStatus: EMapStatus | null;
}

export interface IMapViewExpandedEvent {
  mapStatus: EMapStatus;
}
